import Vue from 'vue'
import HttpService from '@/services/http.service'
import WorkerService from '@/services/worker.service'
import VueFroala from 'vue-froala-wysiwyg'

Vue.use(VueFroala)
Vue.use(HttpService)
Vue.use(WorkerService)
